import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'; // Añade este import
import { Fab } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import * as React from 'react';
import * as Redux from 'react-redux';
import AppBarTemplate from './appbar/Appbar';
import SidebarTemplate from './sidebar';
import { SETTINGS_LAYOUT } from './TemplateReducer';

export const mdTheme = createTheme();

const Template = ({ children }) => {
  const dispatch = Redux.useDispatch();

  const templateStore = Redux.useSelector((state) => state.template);

  const [openSidebar, setOpenSidebar] = React.useState(true);
  const [isScrolled, setIsScrolled] = React.useState(false);
  const openDrawer = 'openDrawer';
  const toggleDrawer = () => {
    setOpenSidebar(!openSidebar);
    localStorage.setItem(openDrawer, !openSidebar);
  };

  React.useEffect(() => {
    const od = localStorage.getItem(openDrawer);
    setOpenSidebar(od ? od === 'true' : true);

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  React.useEffect(() => {
    dispatch({
      type: SETTINGS_LAYOUT,
      payload: {
        ...templateStore.settings,
        openSidebar,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openSidebar]);

  // React.useEffect(() => {
  //   setOpenSidebar(templateStore.settings.openSidebar);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [templateStore.settings.openSidebar]);

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBarTemplate openSidebar={openSidebar} toggleDrawer={toggleDrawer} />
        <SidebarTemplate
          openSidebar={openSidebar}
          toggleDrawer={toggleDrawer}
        />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[200]
                : theme.palette.grey[900],
            flexGrow: 1,
            minHeight: '100vh',
            overflow: 'none',
          }}
        >
          <Toolbar />
          <Container maxWidth={false} sx={{ mt: 2, mb: 2 }}>
            {children}
          </Container>

          <Fab
            color="primary"
            size="small"
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
            }}
            sx={{
              position: 'fixed',
              bottom: 16,
              right: 16,
              display: 'flex',
              opacity: isScrolled ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out',
            }}
          >
            <KeyboardArrowUpIcon />
          </Fab>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Template;
